import * as GlobalFilters from "components/Shared/GlobalFilter/constants"
import { FilterTypes } from "components/Shared/GlobalFilter/types"

export const BenchmarkFilters = {
	[GlobalFilters.VENDORS]: {
		isMulti: true,
		allOption: true,
		initialValue: false,
	},
	[GlobalFilters.DEPARTMENTS]: {
		isMulti: true,
		allOption: true,
		isClearable: true,
		initialValue: false,
	},
	[GlobalFilters.CATEGORIES]: {
		isMulti: true,
		allOption: true,
		initialValue: false,
	},
	[GlobalFilters.SUBCATEGORIES]: {
		isMulti: true,
		allOption: true,
	},
	[GlobalFilters.FINELINE]: {
		isMulti: true,
		allOption: true,
	},
}

export const filtersToShow: Array<FilterTypes> = [
	GlobalFilters.LOCATION_GROUP_FILTER,
	GlobalFilters.PRODUCT_GROUP_FILTER,
]

export default BenchmarkFilters
